module.exports = __webpack_public_path__ + "media/images/newsletters__the-checklist-22913d311df40f56662529e944be1141.jpg";